import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, PropType, ref } from 'vue'
import GenericService from '../shareds/GenericService'
import { alert } from '../store'


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericForm',
  props: {
	service: { type: Object as PropType<GenericService<any, any>>, required: true },
	novo: { type: Boolean, default: false },
	id: { type: String },
	initialExpression: { type: Function as PropType<() => any>, required: true },
	beforeSave: {
		type: Function as PropType<((input: any) => any) | null>, default: null,
	},
	afterLoad: {
		type: Function as PropType<((input: any) => any) | null>, default: null,
	},
},
  emits: ["save"],
  setup(__props, { expose, emit }: { emit: ({
	(e: 'save', resposta: unknown): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const form = ref<HTMLFormElement & {
	validate: (() => boolean),
}>()

const carregando = ref(true)
const erro = ref<string | undefined>(undefined)

const salvando = ref(false)
const versaoAnterior = ref<string | null>(null)
const data = ref(props.initialExpression())

async function carregar() {
	carregando.value = true
	erro.value = undefined
	try {
		const dados = props.novo
			? props.initialExpression()
			: await props.service.get(props.id!)
		data.value = props.afterLoad
			? props.afterLoad(dados)
			: dados
		nextTick().then(() => {
			versaoAnterior.value = JSON.stringify(data.value)
		})
	} catch (error) {
		erro.value = (error as any).message
	} finally {
		carregando.value = false
	}
}

carregar()

async function salvar() {
	if (!form.value!.validate()) {
		console.info("Form inválido")
		return
	}
	salvando.value = true
	try {
		const dataAfterBeforeHook = props.beforeSave
			? await props.beforeSave({...data.value})
			: data.value
		const response = props.novo
			? await props.service.post(dataAfterBeforeHook)
			: await props.service.put(props.id!, dataAfterBeforeHook)
		versaoAnterior.value = JSON.stringify(data.value)
		emit('save', response)
	} catch (error) {
		alert.setError(error)
	} finally {
		salvando.value = false
	}
}

const temAlteracao = computed(() => versaoAnterior.value !== JSON.stringify(data.value))

function validarSaida(): false | void {
	if(!temAlteracao.value) return
	return confirm("Alguns dados não foram salvos. Deseja mesmo sair?") && undefined
}

expose({ data, validarSaida })

return { __sfc: true,props, emit, form, carregando, erro, salvando, versaoAnterior, data, carregar, salvar, temAlteracao, validarSaida }
}

})